import React from 'react'
import styles from './ProtocolInfographic.module.css'

export default function AdherenceRing({ value, accent }) {
  const safeValue = typeof value === 'number' ? value : 0
  const r = 26
  const c = 2 * Math.PI * r
  const offset = c - (safeValue / 100) * c
  return (
    <div className={styles.ringWrapper} title="Current adherence">
      <svg className={styles.ringSvg} viewBox="0 0 64 64">
        <circle className={styles.ringCircleOuter} cx="32" cy="32" r={r} />
        <circle
          className={styles.ringCircleInner}
          cx="32" cy="32" r={r}
          stroke={accent || '#111827'}
          strokeDashoffset={offset}
          strokeDasharray={c}
        />
      </svg>
      <div className={styles.ringLabel}>
        <span className={styles.ringValue}>{safeValue}%</span>
        <span className={styles.ringText}>adhere</span>
      </div>
    </div>
  )
}
